import * as React from 'react';
import { SVGProps } from 'react';

const Security = (props: SVGProps<SVGSVGElement>) => (
    <svg
        width="183"
        height="171"
        viewBox="0 0 183 171"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
    >
        <path
            d="M58.4771 134.798C58.4706 127.812 64.7602 122.504 71.6467 123.685L165.89 139.838C169.132 140.394 171.574 143.094 171.802 146.374C172.105 150.736 168.448 154.341 164.091 153.976L68.8046 146.012C62.9711 145.525 58.4826 140.651 58.4771 134.798Z"
            fill="#FFD1D1"
        />
        <path
            d="M86.2289 64.8159C85.5068 56.6845 92.3823 49.9134 100.503 50.7602L146.91 55.5999C154.256 56.366 159.482 63.0992 158.402 70.405L152.618 109.512C151.543 116.781 144.651 121.708 137.423 120.374L100.094 113.483C94.3623 112.425 90.0388 107.675 89.5234 101.871L86.2289 64.8159Z"
            fill="#FFD1D1"
        />
        <path
            d="M55.6345 110.766L11.0951 100.869C8.19585 100.225 5.40582 102.32 5.21615 105.283L1.90655 156.997C1.73348 159.701 3.81428 162.02 6.52126 162.14L170.574 169.419C173.168 169.534 175.39 167.583 175.61 164.996L178.077 136.105C178.292 133.578 176.52 131.313 174.015 130.915L88.079 117.254"
            stroke="white"
            strokeWidth="3"
            strokeLinecap="round"
        />
        <path
            d="M58.4158 110.766L13.8763 100.869C10.9771 100.225 8.18707 102.32 7.9974 105.283L4.6878 156.997C4.51473 159.701 6.59553 162.02 9.30251 162.14L173.355 169.419C175.949 169.534 178.171 167.583 178.392 164.996L180.858 136.105C181.073 133.578 179.301 131.313 176.796 130.915L90.8602 117.254"
            stroke="#9BA8BA"
            strokeWidth="3"
            strokeLinecap="round"
        />
        <path
            d="M69.2111 140.358C69.6189 137.196 69.6662 135.044 69.2546 131.931C69.1731 131.315 69.6959 130.781 70.3123 130.867L158.395 143.124C158.759 143.175 159.063 143.435 159.145 143.793C159.357 144.713 159.364 145.386 159.182 146.207C159.089 146.627 158.69 146.897 158.262 146.87L70.0769 141.416C69.5374 141.383 69.1415 140.895 69.2111 140.358Z"
            stroke="#9BA8BA"
            strokeWidth="3"
            strokeLinecap="round"
        />
        <path
            d="M30.6643 152.904C25.5433 147.736 22.1609 143.323 19.9453 138.11C17.811 133.087 17.6929 126.632 18.0216 120.93C18.044 120.541 18.3102 120.21 18.6845 120.1L33.4906 115.772"
            stroke="#9BA8BA"
            strokeWidth="3"
            strokeLinecap="round"
        />
        <path
            d="M25.9208 139.425C23.7645 134.799 22.7526 129.656 22.9756 124.48C22.9923 124.093 23.256 123.762 23.6272 123.65L38.9115 119.049C39.1744 118.97 39.4588 119.011 39.6882 119.162L53.9782 128.563C54.2637 128.751 54.4241 129.08 54.3879 129.42C53.8354 134.602 52.0528 139.566 49.2042 143.837C46.3769 148.077 41.7439 150.638 37.2955 152.839C36.9512 153.01 36.5373 152.947 36.2576 152.684C31.3673 148.078 28.0982 144.096 25.9208 139.425Z"
            stroke="#9BA8BA"
            strokeWidth="3"
            strokeLinecap="round"
        />
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M37.923 141.627C38.2506 141.658 38.4653 141.35 39.0509 140.764C39.7829 140.032 40.4863 139.352 40.9987 138.839C42.5121 137.325 43.1045 136.753 43.529 136.302C44.6581 135.105 44.9529 133.327 44.392 131.904C43.6848 130.111 42.4231 129.692 41.7307 129.628C41.0373 129.565 40.5142 129.821 39.568 130.515L38.9022 131.104L38.3707 130.406C37.5054 129.399 36.8322 129.181 36.3908 129.14C36.0228 129.106 34.4859 128.966 33.3111 130.89C32.4539 132.294 32.6658 134.14 33.4804 135.383C33.6263 135.605 34.2318 136.474 35.2779 138.034C35.6991 138.663 36.2972 139.529 36.7358 140.184C36.9842 140.556 37.5955 141.597 37.923 141.627Z"
            stroke="#0063FB"
            strokeWidth="3"
        />
        <path
            d="M88.5259 65.6054L94.9452 100.513C95.6562 104.378 98.9693 107.223 102.899 107.343L132.361 108.234C136.437 108.358 140.004 105.518 140.798 101.518L147.776 66.3124C148.789 61.2004 144.919 56.4212 139.707 56.3491L96.8465 55.7552C91.5877 55.6824 87.5748 60.4335 88.5259 65.6054Z"
            fill="#FFF5C8"
        />
        <path
            d="M112.644 46.9702L120.06 47.2926M68.1489 114.473C85.4112 104.365 94.0127 103.019 108.009 106.033L132.317 112.907C137.98 114.509 143.82 110.998 145.06 105.244L151.698 74.4472C153.066 68.0968 148.226 62.1031 141.729 62.1031H103.903C97.8986 62.1031 93.1942 67.2652 93.7504 73.2435L95.8055 95.3402C96.0345 97.7984 93.1858 99.3129 91.2763 97.7502L89.0839 95.9566C87.2365 94.4457 85.9776 92.3345 85.5271 89.991L79.3923 58.0911C78.1483 51.6249 83.269 45.6932 89.8487 45.9792L92.714 46.1038L68.1489 114.473ZM148.797 58.3954L146.31 53.4245C144.692 50.1879 141.48 48.0516 137.868 47.8108L136.746 47.7359L148.797 58.3954Z"
            stroke="white"
            strokeWidth="3"
            strokeLinecap="round"
        />
        <path
            d="M139.527 49.5898L140.748 49.6712C144.306 49.9084 147.481 51.9863 149.123 55.1513L150.968 58.7114C151.429 59.5992 153.044 59.2289 153.196 58.2406C154.961 46.7699 165.583 32.7923 180.314 24.5632M70.9297 116.327C88.192 106.218 96.7935 104.873 110.79 107.887L135.097 114.761C140.761 116.363 146.6 112.851 147.841 107.098L154.479 76.3011C155.847 69.9507 151.007 63.9569 144.51 63.9569H106.683C100.679 63.9569 95.9749 69.1191 96.5311 75.0974L98.5863 97.1941C98.8152 99.6523 95.9666 101.167 94.057 99.604L91.8647 97.8105C90.0172 96.2996 88.7584 94.1881 88.3079 91.8448L82.1731 59.9449C80.9291 53.4787 86.0497 47.547 92.6295 47.833L95.4948 47.9576L70.9297 116.327ZM115.425 48.8241L122.841 49.1465L115.425 48.8241Z"
            stroke="#9BA8BA"
            strokeWidth="3"
            strokeLinecap="round"
        />
        <path
            d="M114.484 13.9567C103.515 16.7104 106.929 41.973 108.9 52.6936C109.291 54.8128 107.271 56.6488 105.216 56.001L103.68 55.5173C102.668 55.1983 101.931 54.3588 101.798 53.3062C100.7 44.6542 96.7086 5.58845 113.561 2.08991C131.802 -1.6966 132.273 41.1443 132.087 52.352C132.063 53.8402 130.844 54.9961 129.355 54.9961H128.168C126.523 54.9961 125.228 53.5843 125.34 51.9434C126.023 41.9118 127.147 10.7781 114.484 13.9567Z"
            stroke="white"
            strokeWidth="3"
        />
        <path
            d="M116.816 16.6843C105.893 19.2425 109.165 42.5268 111.153 52.7228C111.564 54.8335 109.58 56.7036 107.516 56.0967L105.98 55.645C104.954 55.3432 104.197 54.5009 104.054 53.4407C102.928 45.0846 99.0446 8.82392 115.889 5.56143C134.126 2.029 134.681 41.7903 134.502 52.5224C134.477 54.0071 133.26 55.1511 131.775 55.1511H130.569C128.917 55.1511 127.618 53.7343 127.736 52.0861C128.422 42.4732 129.445 13.7262 116.816 16.6843Z"
            stroke="#9BA8BA"
            strokeWidth="3"
        />
        <path
            d="M117.044 97.903L120.192 91.0409C120.699 89.9361 120.404 88.6483 119.61 87.7267C113.49 80.6221 120.802 74.5956 125.341 74.7599C130.054 74.9304 136.595 83.2787 128.171 89.1922C127.105 89.9405 126.511 91.2424 126.854 92.4997L128.725 99.3499C129.258 101.296 127.607 103.141 125.615 102.829L119.142 101.812C117.321 101.525 116.275 99.5779 117.044 97.903Z"
            stroke="white"
            strokeWidth="3"
        />
        <path
            d="M116.579 96.5331L119.272 90.3852C119.742 89.3128 119.46 88.078 118.728 87.1632C113.493 80.6221 119.914 75.044 123.893 75.1787C128.022 75.3184 133.713 82.9743 126.442 88.4955C125.439 89.2569 124.865 90.5095 125.177 91.7304L126.715 97.7566C127.21 99.6966 125.555 101.506 123.58 101.187L118.686 100.396C116.89 100.106 115.85 98.1987 116.579 96.5331Z"
            fill="#C3CCD9"
            stroke="#9BA8BA"
            strokeWidth="3"
        />
    </svg>
);

export default Security;
